/**
 * Copy + identifiers for the "POS not accepting orders" experience (TEAM-14640).
 *
 * The copy is intentionally hardcoded rather than routed through `StringAccessor`:
 * new CMS string keys are served from the configurations service (`web-strings`) and
 * would not resolve on the client until added to that server-side schema and regenerated,
 * so a new accessor would silently render empty. This mirrors the existing unavailability
 * surfaces (`service-unavailable`, `delivery-unavailable`), which also hardcode their copy.
 */
export const POS_UNAVAILABLE_COPY = {
  bannerMessage:
    "This restaurant can't accept online orders right now. Please try again in a few minutes.",
  callCta: 'Call the restaurant',
  modalTitle: "Can't accept orders right now",
  modalClose: 'Close',
  checkoutMessage:
    "Orders can't be sent to this restaurant right now. Your cart is saved — try again in a few minutes.",
  /** The modal body opens with the restaurant name, matching the Figma comp. */
  modalBody: (restaurantName: string) =>
    `${restaurantName} is temporarily unable to accept online orders. The restaurant is open, but its ordering system is currently unavailable. Please try again in a few minutes.`,
} as const;

/** Distinct analytics event recorded when the POS-availability gate blocks a diner (AC4). */
export const POS_UNAVAILABLE_ANALYTICS_EVENT = 'POS Unavailable Blocked Checkout';

/**
 * DOM id that links the disabled Place Order button to its visible reason text via
 * `aria-describedby` (accessibility note in the ticket's design reference). Rendered by
 * the checkout notice and referenced by the submit button under the same condition.
 */
export const POS_UNAVAILABLE_SUBMIT_REASON_ID = 'pos-unavailable-submit-reason';
